import Vue from "vue";
import App from "./App.vue";
import store from "./store/index";
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueLodash from 'vue-lodash'

Vue.use(VueAxios, axios, VueLodash)

new Vue({
  store,
  render: h => h(App)
}).$mount("#app");